import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { HouseDoor, BoxArrowInDown } from 'react-bootstrap-icons';
import {Dashboard} from './Dashboard';
import {Pipeline} from './Pipeline';

const UserDashboard: React.FC = () => {
  const userFirstName = 'Thomas'; // Replace this with the actual user's first name
  return (
    <>
      <DashboardWrapper>
        <Sidebar>
          <SidebarLogo>Hello, {userFirstName}</SidebarLogo>
          <SidebarMenu>
            <SidebarMenuItem>
            <ActiveSidebarMenuLink to="/dashboard">
            <IconWrapper><HouseDoor /></IconWrapper>
              Dashboard
            </ActiveSidebarMenuLink>
            </SidebarMenuItem>
            <SidebarMenuItem>
            <ActiveSidebarMenuLink to="/pipeline">
              <IconWrapper><BoxArrowInDown /></IconWrapper>
              Pipeline
            </ActiveSidebarMenuLink>
            </SidebarMenuItem>
          </SidebarMenu>
        </Sidebar>
        <MainContent>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pipeline" element={<Pipeline />} />
          </Routes>
        </MainContent>
      </DashboardWrapper>
    </>
  );
};

const DashboardWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

// const Sidebar = styled.div`
//   background-color: #007bff;
//   width: 240px;
//   display: flex;
//   flex-direction: column;
// `;

const SidebarLogo = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem;
  color: #333;
`;

const SidebarMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SidebarMenuItem = styled.li`
  padding: 0;
  margin: 0;
`;

// const SidebarMenuLink = styled(Link)`
//   display: block;
//   padding: 1rem;
//   color: white;
//   text-decoration: none;

//   &:hover {
//     background-color: rgba(255, 255, 255, 0.1);
//   }
// `;

const MainContent = styled.div`
  flex-grow: 1;
  padding: 2rem;
`;

export { UserDashboard };

const Sidebar = styled.div`
  background-color: #f5f9fd;
  width: 240px;
  display: flex;
  flex-direction: column;
`;

const SidebarMenuLink = styled(NavLink)`
  display: block;
  padding: 1rem;
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0056b3;
  }
`;

const ActiveSidebarMenuLink = styled(SidebarMenuLink).attrs({ activeClassName: 'active' })`
  &.active {
    background-color: #007bff;
    color: white;
    font-weight: bold;
  }
`;

const IconWrapper = styled.span`
  margin-right: 8px;
`;